import React, { FunctionComponent } from 'react';
import { makeStyles } from '@mui/styles';
import { Drawer, closeDrawer, useGlobalization } from '@innovyze/stylovyze';
import { useDispatch } from 'react-redux';

export enum HELP_DRAWER {
	OVERVIEW = 'overviewHelp',
	SETUP_DETERIORATION_METHOD = 'setupDeteriorationMethodHelp',
	MODEL_RESULTS = 'modelResultsHelp',
}

export const getHelpURL = (type: HELP_DRAWER) => {
	switch (type) {
		case HELP_DRAWER.OVERVIEW:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-78AFF8EE-0C17-45FD-99F2-00C68A4F5F63';
		case HELP_DRAWER.SETUP_DETERIORATION_METHOD:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-FCC325C3-6A66-463A-931F-BCE155FC0D8F';
		case HELP_DRAWER.MODEL_RESULTS:
			return 'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-FCC325C3-6A66-463A-931F-BCE155FC0D8F';
	}
};

interface HelpDrawerProps {
	drawerID: HELP_DRAWER;
	onClose?: () => void;
}

const useStyles = makeStyles({
	drawer: {
		width: '34.5rem',
		zIndex: 1300,
		inset: 'unset',
	},
	iFrame: {
		height: 'calc(100% - 4px)',
		width: '100%',
	},
});

const HelpDrawer: FunctionComponent<HelpDrawerProps> = ({ drawerID, onClose }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { t } = useGlobalization();

	const close = () => {
		dispatch(closeDrawer());
		onClose?.();
	};

	return (
		<Drawer
			drawerId={drawerID}
			onClose={close}
			className={classes.drawer}
			hideBackdrop
			disableEnforceFocus
			padContent={false}
			action={{
				label: t('Close'),
				onClick: close,
			}}>
			<iframe src={getHelpURL(drawerID)} title="Help page" className={classes.iFrame}></iframe>
		</Drawer>
	);
};

export default HelpDrawer;
